import React, { useEffect } from "react";
import { Odometer } from "odometer_countup";
import { CountUp } from "countup.js";

const PromoTicker = ({
  startTicker,
  valuationBeforePromo,
  valuationAfterPromo
}: {
  startTicker: boolean;
  valuationBeforePromo: number;
  valuationAfterPromo: number;
}) => {
  const counter = new CountUp("counter", valuationAfterPromo, {
    startVal: valuationBeforePromo,
    duration: 1,
    plugin: new Odometer({ duration: 1, lastDigitDelay: 0 })
  });

  useEffect(() => {
    if (startTicker) counter.start();
  }, [startTicker]);

  return <span id="counter">{valuationBeforePromo.toLocaleString()}</span>;
};

export default PromoTicker;
